import {
  FETCH_ALL_AIRPORT_FAILURE,
  FETCH_ALL_AIRPORT_REQUEST,
  FETCH_ALL_AIRPORT_SUCCESS,
} from '../Airports/types/airportTypes';
import {
  FETCH_ALL_SERVICES_FAILURE,
  FETCH_ALL_SERVICES_REQUEST,
  FETCH_ALL_SERVICES_SUCCESS,
  RESET_SERVICE_DETAILS,
  SERVICE_ADD_FAILURE,
  SERVICE_ADD_REQUEST,
  SERVICE_ADD_SUCCESS,
  SERVICE_DELETE_FAILURE,
  SERVICE_DELETE_REQUEST,
  SERVICE_DELETE_SUCCESS,
  SERVICE_UPDATE_FAILURE,
  SERVICE_UPDATE_REQUEST,
  SERVICE_UPDATE_SUCCESS,
  SERVICE_VIEW_ALL_FAILURE,
  SERVICE_VIEW_ALL_REQUEST,
  SERVICE_VIEW_ALL_SUCCESS,
  SERVICE_VIEW_FAILURE,
  SERVICE_VIEW_REQUEST,
  SERVICE_VIEW_SUCCESS,
  UPDATE_SERVICE_APPROVAL_FAILURE,
  UPDATE_SERVICE_APPROVAL_REQUEST,
  UPDATE_SERVICE_APPROVAL_SUCCESS,
} from './ServiceType';

export const serviceViewRequest = (payload) => {
  return {
    type: SERVICE_VIEW_REQUEST,
    payload,
  };
};
export const serviceViewSuccess = (payload) => {
  return {
    type: SERVICE_VIEW_SUCCESS,
    payload,
  };
};
export const serviceViewFailure = (payload) => {
  return {
    type: SERVICE_VIEW_FAILURE,
    payload,
  };
};
export const serviceViewAllRequest = (payload) => {
  console.log('response');
  return {
    type: SERVICE_VIEW_ALL_REQUEST,
    payload,
  };
};
export const serviceViewAllSuccess = (payload) => {
  return {
    type: SERVICE_VIEW_ALL_SUCCESS,
    payload,
  };
};
export const serviceViewAllFailure = (payload) => {
  return {
    type: SERVICE_VIEW_ALL_FAILURE,
    payload,
  };
};
export const serviceAddRequest = (payload) => {
  return {
    type: SERVICE_ADD_REQUEST,
    payload,
  };
};
export const serviceAddSuccess = (payload) => {
  return {
    type: SERVICE_ADD_SUCCESS,
    payload,
  };
};
export const serviceAddFailure = (payload) => {
  return {
    type: SERVICE_ADD_FAILURE,
    payload,
  };
};
export const serviceUpdateRequest = (payload) => {
  return {
    type: SERVICE_UPDATE_REQUEST,
    payload,
  };
};
export const serviceUpdateSuccess = (payload) => {
  return {
    type: SERVICE_UPDATE_SUCCESS,
    payload,
  };
};
export const serviceUpdateFailure = (payload) => {
  return {
    type: SERVICE_UPDATE_FAILURE,
    payload,
  };
};
export const serviceDeleteRequest = (payload) => {
  return {
    type: SERVICE_DELETE_REQUEST,
    payload,
  };
};
export const serviceDeleteSuccess = (payload) => {
  return {
    type: SERVICE_DELETE_SUCCESS,
    payload,
  };
};
export const serviceDeleteFailure = (payload) => {
  return {
    type: SERVICE_DELETE_FAILURE,
    payload,
  };
};
export const fetchAllServiceRequest = () => {
  return {
    type: FETCH_ALL_SERVICES_REQUEST,
  };
};
export const fetchAllServiceSuccess = (payload) => {
  return {
    type: FETCH_ALL_SERVICES_SUCCESS,
    payload,
  };
};
export const fetchAllServiceFailure = (payload) => {
  return {
    type: FETCH_ALL_SERVICES_FAILURE,
    payload,
  };
};

export const resetServiceDetails = () => {
  return {
    type: RESET_SERVICE_DETAILS,
  };
};
export const updateServiceApprovalRequest = (serviceId, status) => ({
  type: UPDATE_SERVICE_APPROVAL_REQUEST,
  payload: { serviceId, status },
});

export const updateServiceApprovalSuccess = (message) => ({
  type: UPDATE_SERVICE_APPROVAL_SUCCESS,
  payload: message,
});

export const updateServiceApprovalFailure = (error) => ({
  type: UPDATE_SERVICE_APPROVAL_FAILURE,
  payload: error,
});
